let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("440Mx")).then(() => parcelRequire('r0ivy'));